<template>
    <div class="box-white-wrapper address-miami">
        <div class="title">
            <div class="icon">
                <img src="@/assets/images/deliveries/3.png" />
            </div>
            <h3>Tu dirección en Miami es la siguiente:</h3>
        </div>
        <div class="detail">
            <div class="item">
                <p><strong>Nombre:</strong></p>
                <p>SJO375592 {{userInfoData.name + " " + userInfoData.lastName}}</p> 
            </div>
            <div class="item">
                <p><strong>Dirección:</strong></p>
                <p>2020 Nw 129th Av ste 201</p>
            </div>
            <div class="item">
                <p><strong>Ciudad:</strong></p>
                <p>Miami</p>
            </div>
            <div class="item">
                <p><strong>Estado:</strong></p>
                <p>Florida</p>
            </div>
            <div class="item">
                <p><strong>Zip Code:</strong></p>
                <p>33182</p>
            </div>
            <div class="item">
                <p><strong>Número de teléfono:</strong></p> 
                <p>+1 305 4567884</p>
            </div>
        </div>
        <vs-alert title="Nota" active="true">
            <p>Es importante que el SJO375592, esté colocado a la par de tu nombre. Si la tienda no te lo permite colócalo en la dirección antes del "2020"</p>
        </vs-alert>
    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { mapState } from 'vuex'
export default {
  name: "Customer",
  mixins: [helper],
  data () {
    return {
      cashbackData: [],
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  created(){
    this.Roles = Role
  },
  methods: {

  }
}
</script>
